// Platform detection shared across the chat client.
//
// iOS/iPadOS Safari permits only ONE active camera capture at a time, so several
// places (the publish/hot-swap path in App.js, the device-setup modal preview)
// must special-case it: holding the live camera while opening a second
// getUserMedia for the same or another camera fails or silently kills the live
// track. iPadOS 13+ reports a desktop "MacIntel" platform UA, so the
// touch-points check is what distinguishes an iPad from a real Mac; the
// /iP(hone|ad|od)/ test catches everything else.
export const isIOS = () => {
  if (typeof navigator === "undefined") return false
  const ua = navigator.userAgent || ""
  if (/iP(hone|ad|od)/.test(ua)) return true
  const plat = navigator.userAgentData?.platform || navigator.platform || ""
  return /Mac/i.test(plat) && navigator.maxTouchPoints > 1
}
